//#region src/url/url-scheme-enum.ts
var e = /* @__PURE__ */ function(e) {
	return e.Https = "https://", e.Mailto = "mailto:", e.Tel = "tel:", e;
}({});
//#endregion
export { e as UrlSchemeEnum };
